module.exports = require("core-js/library/fn/object/assign");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/core-js/object/assign.js
// module id = 149
// module chunks = 35783957827783 70144966829960 114276838955818 198517197184460